import { render, staticRenderFns } from "./ClientReport.vue?vue&type=template&id=72e14c19&scoped=true&lang=pug"
import script from "./ClientReport.js?vue&type=script&lang=js&external"
export * from "./ClientReport.js?vue&type=script&lang=js&external"
import style0 from "./ClientReport.vue?vue&type=style&index=0&id=72e14c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e14c19",
  null
  
)

export default component.exports